// Default site content — mirrors the currently hard-coded copy on CourseSelection.jsx.
// The admin CMS ("Website aanpassen" tab) allows the user to override any of these
// fields. When published content is missing a field, we fall back to the default.

import {
  COURSE_LIST, TRAINER, WHATSAPP_DM_URL,
} from "@/lib/api";

export const DEFAULT_CONTENT = {
  hero: {
    label: "— Pattern Texture Academy",
    urgency_template: "Nog {n} plekken beschikbaar",
    title_line1: "Leer in",
    title_italic: "3 dagen",
    title_line2: "professioneel weaven met leave-out",
    subtitle: "17, 18 & 19 juli · 11:00 – 18:00 · Rotterdam · Kleine groep · Nog {n} plekken beschikbaar.",
    primary_cta: "Reserveer mijn plek",
    secondary_cta: "Ik twijfel nog — app Quimarich",
    trust_bullets: [
      "Kleine groepen",
      "Persoonlijke begeleiding",
      "Alle materialen inbegrepen",
      "18 uur praktijk",
    ],
  },
  courses: COURSE_LIST.map((c) => ({
    id: c.id,
    name: c.name,
    subtitle: c.subtitle,
    date_line: c.dateLine,
    price: c.price,
    total_spots: c.totalSpots,
    available_spots: null,   // null → use automatic availability
    status: "open",           // "open" | "sold_out" | "waitlist"
    waitlist: false,
    visible: true,
    cta_text: "Reserveer Mijn Plek",
  })),
  trainer: {
    name: TRAINER.name,
    role: TRAINER.role,
    intro: TRAINER.intro,
    passion: TRAINER.passion,
    photo: TRAINER.photo,
  },
  sales_texts: {
    outcome_html: "Na deze 3 dagen weet je hoe je een leave-out sew-in <strong>platter</strong>, <strong>netter</strong> en <strong>professioneler</strong> plaatst. Je leert niet alleen <em>wat</em> je moet doen, maar ook <em>waarom</em> je het doet — zodat je met meer zekerheid kunt werken en klanten langer tevreden blijven.",
    for_who_html: "Deze cursus is voor <strong>beginnende en ambitieuze hairstylisten</strong> die hun sew-in techniek willen verbeteren. Je hoeft nog geen expert te zijn, maar je moet wel serieus willen leren en bereid zijn om te oefenen.",
    doubt_text: "App mij eerst. Ik kijk eerlijk met je mee en vertel je of deze training goed aansluit bij jouw niveau.",
    curriculum_bullets: [
      "De juiste braid pattern voor een platte leave-out install",
      "Tracks strak en netjes plaatsen",
      "Minder banen knippen",
      "Fold-over / dubbelbaan techniek",
      "Natuurlijk blenden van de leave-out",
      "Professionele afwerking voor foto's en video's",
      "Hoe je klanten langer tevreden houdt",
      "Tips om je werk beter te verkopen via social media",
    ],
    final_cta_title: "Klaar om jouw skills naar een hoger niveau te tillen?",
    final_cta_body: "Beperkte plaatsen. Persoonlijke begeleiding. Alle materialen inbegrepen.",
  },
  faq: [],
  announcement: {
    enabled: false,
    text: "",
  },
  whatsapp: {
    phone: "31621278150",
    default_message: "Hoi! Ik heb een vraag over de Pattern Texture cursus.",
    dm_url: WHATSAPP_DM_URL,
  },
};

// Deep-merge published content over defaults. Only overrides fields that exist.
function isPlainObject(v) {
  return v !== null && typeof v === "object" && !Array.isArray(v);
}

export function mergeContent(defaults, override) {
  if (!override) return defaults;
  const out = Array.isArray(defaults) ? [...defaults] : { ...defaults };
  for (const key of Object.keys(override)) {
    const dv = defaults?.[key];
    const ov = override[key];
    if (ov === undefined || ov === null) continue;
    if (isPlainObject(ov) && isPlainObject(dv)) {
      out[key] = mergeContent(dv, ov);
    } else {
      out[key] = ov;
    }
  }
  return out;
}

// Build a full whatsapp dm URL from a whatsapp settings block.
export function buildWhatsAppUrl(whatsapp) {
  if (!whatsapp) return DEFAULT_CONTENT.whatsapp.dm_url;
  const phone = (whatsapp.phone || DEFAULT_CONTENT.whatsapp.phone).replace(/[^0-9]/g, "");
  const msg = whatsapp.default_message || DEFAULT_CONTENT.whatsapp.default_message;
  return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
}

export function formatUrgency(template, n) {
  return (template || "Nog {n} plekken beschikbaar").replace(/\{n\}/g, String(n));
}
